module.exports = __webpack_public_path__ + "media/images/static/top/urban/right_photo_bg-35e90f0e5633bd08884d2771ecf87069.png";